import React from "react";
import { HandHeart } from "lucide-react";
import { SectionLayout } from "@/components/SectionLayout";
import { JanazahGuide } from "@/components/guide/JanazahGuide";

export const JanazahSection = () => (
  <SectionLayout id="janazah" icon={HandHeart}>
    <JanazahGuide />
  </SectionLayout>
);
